import Modal from './modal';

const settings = {
    selectors: {
        template: '.axogen-site-modal',
        yesButton: '.modal__yes-button',
        noButton: '.modal__no-button',
        externalLinks: 'a[data-axogen-site]',
    },
};

let template = null;

export default class AxogenSiteModal extends Modal {
    constructor(externalLink) {
        // Stop if we didn't locate our template
        if (!template) {
            throw new Error();
        }

        // Call base constructor
        super(template);

        // Setup buttons
        let button = this.container
            .querySelector(settings.selectors.yesButton);
        if (button) {
            button.addEventListener('click', (event) => {
                event.preventDefault();

                // Open the link in a new tab
                window.open(externalLink.href);

                // Close the modal
                this.close(true);
            });
        }

        button = this.container
            .querySelector(settings.selectors.noButton);
        if (button) {
            button.addEventListener('click', (event) => {
                event.preventDefault();

                // Close the modal
                this.close();
            });
        }
    }

    static setupExternalLinks(
        container = document,
    ) {
        if (!template) {
            // Locate our template element and remove it from the DOM
            template = document.querySelector(settings.selectors.template);

            if (!template) {
                throw new Error();
            }

            template.remove();
            template = template.outerHTML;
        }

        // Add click events to all of our associated external links
        const externalLinks = container
            .querySelectorAll(settings.selectors.externalLinks);
        for (const externalLink of externalLinks) {
            const modal = new AxogenSiteModal(externalLink);

            externalLink.addEventListener('click', (event) => {
                event.preventDefault();

                modal.show();
            });
        }
    }
}
